// extracted by mini-css-extract-plugin
export default {"item":"styles_item__vQoWQ","item-value":"styles_item-value__mJTU-","counter":"styles_counter__gY-xm"};